<div class="product-detail-wrapper">
    <div class="product-detail-box">
        <div class="container-fluid" *ngIf="product">
            <label class="back-button mb-3" (click)="backCategory(category)">
                <em class="fas fa-angle-left"></em> Volver
            </label>
            <div class="row product-detail-container g-4 align-items-start">
                <div class="col-md-4 image-section">
                    <div class="image-card-wrapper border-rounded">
                        <!-- Texto debajo del carrusel -->
                        <div class="image-caption">
                            Imagen de referencia
                        </div>

                        <!-- Carrusel -->
                        <div id="carrouselImages" class="carousel slide" data-interval="false">
                            <div class="carousel-inner">

                                <!-- Elemento principal -->
                                <div class="carousel-item active">
                                    <ng-container *ngIf="isVideo(product.imagen); else mainImage">
                                        <ng-container *ngIf="isYouTube(product.imagen); else mp4Video">
                                            <iframe width="210" height="200" [src]="getYouTubeEmbedUrl(product.imagen)"
                                                frameborder="0" allowfullscreen>
                                            </iframe>
                                        </ng-container>
                                        <ng-template #mp4Video>
                                            <video width="210" height="200" controls>
                                                <source [src]="product.imagen" type="video/mp4" />
                                            </video>
                                        </ng-template>
                                    </ng-container>
                                    <ng-template #mainImage>
                                        <img class="main-image" alt="principal-img" [src]="product.imagen" width="290px"
                                            height="320px"
                                            onerror="this.onerror=null; this.src='../../../../assets/imgs/Img-our-products/generic-img.svg';" />
                                    </ng-template>
                                </div>

                                <!-- Elementos secundarios -->
                                <div class="carousel-item second-img" *ngFor="let media of product.imagenSegundaria">
                                    <ng-container *ngIf="isVideo(media); else secondaryImage">
                                        <ng-container *ngIf="isYouTube(media); else mp4SecondaryVideo">
                                            <iframe width="210" height="200" [src]="getYouTubeEmbedUrl(media)"
                                                frameborder="0" allowfullscreen>
                                            </iframe>
                                        </ng-container>
                                        <ng-template #mp4SecondaryVideo>
                                            <video width="210" height="200" controls>
                                                <source [src]="media" type="video/mp4" />
                                            </video>
                                        </ng-template>
                                    </ng-container>
                                    <ng-template #secondaryImage>
                                        <img class="main-image" alt="secondary-img" [src]="media" width="290px"
                                            height="320px"
                                            onerror="this.onerror=null; this.src='../../../../assets/imgs/Img-our-products/generic-img.svg';" />
                                    </ng-template>
                                </div>
                            </div>

                            <!-- Controles del carrusel -->
                            <a *ngIf="product.imagenSegundaria && product.imagenSegundaria.length > 0"
                                class="carousel-control-prev control-arrow" href="#carrouselImages" role="button"
                                data-slide="prev">
                                <em class="fas fa-angle-left"></em>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a *ngIf="product.imagenSegundaria && product.imagenSegundaria.length > 0"
                                class="carousel-control-next control-arrow" href="#carrouselImages" role="button"
                                data-slide="next">
                                <em class="fas fa-angle-right"></em>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>

                        <!-- Badges de peso -->
                        <div class="package-badge mt-2" *ngIf="product.pesoVariable">
                            Paquete de {{ product.pesoGramosVariable / 1000 }}Kg | {{ product.pesoGramosVariable / 1000
                            * 2 }}lb aprox.
                        </div>
                        <div class="package-badge mt-2" *ngIf="!product.pesoVariable">
                            Paquete por {{ product.pesoGramos }}gr
                        </div>
                    </div>

                    <!-- Thumbnails -->
                    <div class="thumbnails d-flex justify-content-center mt-3 gap-2">
                        <ng-container *ngFor="let img of product.imagenSegundaria; let i = index">
                            <div class="thumbnail-wrapper" (click)="goToSlide(i + 1)">
                                <img [src]="isYouTube(img) ? getYouTubeThumbnail(img) : img" class="thumbnail"
                                    alt="thumbnail-img"
                                    onerror="this.onerror=null; this.src='../../../../assets/imgs/Img-our-products/generic-img.svg';" />
                                <div *ngIf="isVideo(img)" class="thumbnail-icon">
                                    <em class="fas fa-play-circle"></em>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- ######## -->
                <!-- <div class="col-md-4 image-section">
                    <div class="image-card-wrapper">
                        <div class="main-image-wrapper border-rounded">
                            <div class="image-caption">
                                Imagen de referencia
                            </div>
                            <img class="main-image" alt="principal-img" [src]="product.imagen" width="290px"
                                height="320px" />
                            <div class="package-badge" *ngIf="product.pesoVariable">
                                Paquete de {{ product.pesoGramosVariable / 1000 }}Kg | {{ product.pesoGramosVariable / 1000 * 2 }}lb aprox.
                            </div>
                            <div class="package-badge" *ngIf="!product.pesoVariable">
                                Paquete por {{ product.pesoGramos }}gr
                            </div>
                        </div>
                    </div>

                    <div class="thumbnails d-flex justify-content-center mt-3 gap-2">
                        <ng-container *ngFor="let img of product.imagenSegundaria; let i = index">
                            <div class="thumbnail-wrapper">
                                <img [src]="img" class="thumbnail" (click)="mainImage = img" alt="thumbnail-img"/>
                                <div *ngIf="img.includes('video')" class="thumbnail-icon">
                                    <em class="fas fa-play-circle"></em>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div> -->
                <!-- ######## -->


                <div class="col-md-4 detail-section">
                    <h2 class="product-title">{{ product.nombre }}</h2>

                    <hr class="product-divider" />

                    <p class="product-description" *ngIf="product.descripcion">{{ product.descripcion }}</p>

                    <div class="price-block">
                        <h3 class="price" *ngIf="product.pesoVariable">
                            {{ pricePerPound(product.precio, product.pesoGramosVariable, product.pesoGramos) |
                            customCurrency }}
                            <span class="price-label">Libra</span>
                        </h3>
                        <h3 class="price" *ngIf="!product.pesoVariable">
                            {{ product.precio | customCurrency }}
                        </h3>
                        <span class="price-per-gram">
                            Gramo a ${{ formattedPesoGramos }}
                        </span>
                    </div>
                </div>

                <div class="col-md-4 summary-section">
                    <div class="presentation-box">
                        <h5 class="presentation-title">Presentación del producto</h5>
                        <div class="presentation-line">
                            <span class="label">Empaque</span>
                            <div class="value">{{ product.unidad }}</div>
                        </div>
                        <div class="presentation-line">
                            <span class="label">Peso aproximado del producto</span>
                            <div class="value" *ngIf="product.pesoVariable">
                                {{ product.pesoGramosVariable / 1000 }}kg | {{
                                (product.pesoGramosVariable / 1000) * 2}}lb
                            </div>
                            <div class="value" *ngIf="!product.pesoVariable">
                                {{ product.pesoGramos }}gr
                            </div>
                        </div>
                        <div class="peso-variable" *ngIf="product.pesoVariable">
                            Peso variable <img class="info-img" src="../../../../assets/icons/info-img.svg"
                                alt="info-img" />
                        </div>
                    </div>

                    <div class="mt-3">
                        <ng-container *ngIf="product.add; else addToCart">
                            <div class="btn-black btn-block d-flex align-items-center justify-content-center gap-3">
                                <button class="icon-btn" (click)="removeProduct()" aria-label="Quitar">
                                    <img class="delete-icon" *ngIf="product.quantity === 1"
                                        src="../../../../assets/icons/shopping-cart/delete_icon.svg"
                                        alt="delete-icon" />
                                    <img class="remove-icon" *ngIf="product.quantity > 1"
                                        src="../../../../assets/icons/shopping-cart/remove_circle.svg"
                                        alt="remove-circle" />
                                </button>
                                <span class="quantity-value">{{ product.quantity }}</span>
                                <button class="icon-btn" (click)="moreOneProduct()" aria-label="Agregar">
                                    <img class="add-icon" src="../../../../assets/icons/shopping-cart/add_circle.svg"
                                        alt="add-circle" />
                                </button>
                            </div>
                        </ng-container>

                        <ng-template #addToCart>
                            <button class="btn btn-black btn-block" (click)="addProduct()">
                                Agregar <img class="cart-shopping"
                                    src="../../../../assets/icons/shopping-cart/shopping_cart.svg"
                                    alt="cart-shopping" />
                            </button>
                        </ng-template>

                    </div>

                </div>
            </div>
        </div>

    </div>




    <!-- <div class="col-md-5 col-xs-12">
            <div class="card">
                <div class="card-body">
                    <div id="carrouselImages" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="img-container">
                                    <img alt="Imagen principal" [src]="product.imagen" width="290px" height="320px" />
                                </div>
                            </div>

                            <div class="carousel-item" *ngFor="let imagesSeconds of product.imagenSegundaria">
                                <div class="img-container">
                                    <img alt="Imagen secundaria" [src]="imagesSeconds" width="290px" height="320px" />
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carrouselImages" role="button" data-slide="prev">
                            <em class="fas fa-angle-left"></em>

                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carrouselImages" role="button" data-slide="next">
                            <em class="fas fa-angle-right"></em>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
                <div class="card-footer">
                    Imagen de referencia
                </div>
            </div>
        </div> -->

    <!-- <div class="col-md-7 col-xs-12 col-info">
            <label class="name h2"> {{ product.nombre }}</label>
            <div class="row">
                <div class="col-12">
                    <div class="variable-weight-tag" *ngIf="product.pesoVariable">
                        Peso variable
                    </div>
                </div>
            </div>
            <label class="price h1" *ngIf="product.pesoVariable">
                {{ pricePerPound(product.precio, product.pesoGramosVariable, product.pesoGramos) | customCurrency }}
                Libra
            </label>
            <label class="price h1" *ngIf="!product.pesoVariable">
                {{ product.precio | customCurrency }}
            </label>
            <label class="description h5">Descripción</label>

            <div class="row">
                <div class="col-12 description h6" *ngIf="product?.descripcion">
                    {{ product.descripcion }}
                </div>
                <div class="col-6 description h6" *ngIf="product.pesoVariable">
                    - Peso aproximado
                </div>
                <div class="col-6 description h6" *ngIf="!product.pesoVariable">
                    - Peso neto
                </div>
                <div class="col-6 description h6" *ngIf="product.pesoVariable">
                    {{ product.pesoGramosVariable / 1000 }} Kg | {{ (product.pesoGramosVariable / 1000) * 2 }} Lib.
                </div>
                <div class="col-6 description h6" *ngIf="!product.pesoVariable">
                    {{ product.pesoGramos }} gr
                </div>

                <div class="col-6 description h6">- Precio por gramo</div>
                <div class="col-6 description h6">${{ costForGram | number }}/gr</div>

                <div class="col-6 description h6">- Empaque</div>
                <div class="col-6 package h6">{{ product.unidad }}</div>
            </div>

            <ng-container *ngIf="product || user && user.tipoCuenta !== 'B2B'">
                <div class="row row-btn-quantity" *ngIf="product.cobertura">
                    <div *ngIf="product.add" class="ml-3 col-quantity">
                        <button class="remove" (click)="removeProduct()">-</button>
                        <button class="quantity">{{ product.quantity }}</button>
                        <button class="add" (click)="moreOneProduct()">+</button>
                    </div>

                    <div *ngIf="!product.add" class="ml-3" (click)="addProduct()">
                        <div type="button" class="btn card-button">
                            + Agregar al carrito
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="user && user.tipoCuenta === 'B2B'">
                <div class="row-btn-quantity" style="gap: 8px;" *ngIf="product.cobertura">
                    <div *ngIf="product.add" class="d-flex">
                        <button class="add-b2b" (click)="removeQuantityProduct()">
                            <img src="../../../../assets/icons/shopping-cart/delete.svg" alt="trash can icon">
                        </button>
                    </div>
                    <input type="number" min="0" max="999" class="cantidad-b2b" [(ngModel)]="quantityProduct"
                        placeholder="Cantidad" [value]="(product.quantity > 0) ? product.quantity : ''"
                        (ngModelChange)="changeQuantityProduct()" maxlength="3" (input)="validateInput($event)">
                    <button *ngIf="product.quantity === 0 || !checkProductIcon" (click)="addQuantityProduct()"
                        type="button" class="btn add-b2b">
                        <img src="../../../../assets/imgs/Img-our-products/add_product.svg" alt="add product icon">
                    </button>
                    <button *ngIf="product.quantity > 0 && checkProductIcon" type="button" class="btn add-b2b">
                        <img src="../../../../assets/icons/shopping-cart/check-product.svg" alt="check product icon">
                    </button>
                </div>
            </ng-container>
        </div> -->
    <!-- </div> -->

    <!-- <div class="row" style="justify-content:left;" *ngIf="nutriInfo">
        <div class="col-md-5 col-xs-12">
            <label class="description-infoNutri h5">Información nutricional</label>
        </div>
    </div>
    <div class="row" style="justify-content:left;" *ngIf="nutriInfo">
        <div class="col-md-5 col-xs-12">
            <div class="card">
                <div class="card-body">
                    <div id="carrouselInfoNutri" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item"
                                *ngFor="let nutritionalImage of product.infoNutricional let i = index"
                                [ngClass]="{'active': i == 0 }">
                                <div class="img-infoNutri">
                                    <img alt="InfoNutricional" [src]="nutritionalImage" width="310px" height="340px" />
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carrouselInfoNutri" role="button" data-slide="prev">
                            <em class="fas fa-angle-left"></em>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carrouselInfoNutri" role="button" data-slide="next">
                            <em class="fas fa-angle-right"></em>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <app-related-products [product]="product"></app-related-products>
    <app-video-product [product]="product"></app-video-product>
</div>
